import React from 'react';
import { Link } from 'react-router-dom';

function Footer(props) {
    return(
        <div className="footer">
            <div className="container">
                <div className="row ">             
                    <div className="col-9">
                        <h5>Links</h5>
                        <ul className="list-unstyled">
                            <li><Link to="/home">Home</Link></li>
                            <li><Link to="/finance">Finance</Link></li>
                            <li><Link to="/auto">Auto</Link></li>
                            <li><Link to="/keto">Keto</Link></li>
                            <li><Link to="/adventure">Adventure</Link></li>
                        </ul>
                    </div>
                    <div className="col-3 align-self-center">
                        <div className="text-center">
                            <a className="btn btn-social-icon btn-github" href="https://aaronjohn2.github.io" target="_blank" rel="noopener noreferrer">
                                <i className="fa fa-github"></i>
                            </a>
                        </div>
                    </div>
                </div>
                <div className="row justify-content-center">             
                    <div className="col-auto">
                        <p>Copyright © {new Date().getFullYear()} AJ's Logbook</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Footer;


// WEBPACK FOOTER //
// ./src/components/FooterComponent.js